import styled from 'styled-components';

import { HOME, SPACE } from '../../../../theme/tokens';
import { pulseCard } from '../../../../theme/mixins';
import { Text } from '../../../../components';

export const Frame = styled.div`
  ${pulseCard}
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${SPACE[12]};
  padding: ${SPACE[24]};
`;

export const Title = styled(Text)`
  margin: ${SPACE[0]};
  font-size: 18px;
  font-weight: 600;
  color: ${HOME.t50};
`;

export const Body = styled(Text)`
  margin: ${SPACE[0]};
  max-width: 560px;
  font-size: 15px;
  line-height: 1.5;
  color: ${HOME.t300};
`;
